import { HelpSupportActionTypes } from './constants';

const CREATE_SUPPORT_DATA_INITIAL_STATE = {
    createSupport: [],
    loading: false,
};

const GET_SUPPORT_DATA_INITIAL_STATE = {
    support: [],
    loading: false,
};

const GET_SUPPORT_ADMIN_DATA_INITIAL_STATE = {
    supportAdmin: [],
    loading: false,
};

const UPDATE_SUPPORT_DATA_INITIAL_STATE = {
    supportData: [],
    loading: false,
};

const CREATE_CHAT_DATA_INITIAL_STATE = {
    createChat: [],
    loading: false,
};

const GET_CHAT_DATA_INITIAL_STATE = {
    getChat: [],
    loading: false,
};

const GET_TICKET_BY_ID_INITIAL_STATE = {
    getTicket: [],
    loading: false
}

const createSupportReducer = (state = CREATE_SUPPORT_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case HelpSupportActionTypes.CREATE_SUPPORT_DATA_LOADING:
            return {
                createSupport: state.createSupport,
                loading: true,
            };
        case HelpSupportActionTypes.CREATE_SUPPORT_DATA_SUCCESS:
            return {
                createSupport: action.payload,
                loading: false,
            };
        case HelpSupportActionTypes.CREATE_SUPPORT_DATA_RESET:
            return CREATE_SUPPORT_DATA_INITIAL_STATE;
        case HelpSupportActionTypes.CREATE_SUPPORT_DATA_ERROR:
            return {
                createSupport: action.payload,
                loading: false,
            };

        default:
            return state;
    }
};
const supportReducer = (state = GET_SUPPORT_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case HelpSupportActionTypes.SUPPORT_DATA_LOADING:
            return {
                support: state.support,
                loading: true,
            };
        case HelpSupportActionTypes.SUPPORT_DATA_SUCCESS:
            return {
                support: action.payload,
                loading: false,
            };
        case HelpSupportActionTypes.SUPPORT_DATA_ERROR:
            return {
                support: action.payload,
                loading: false,
            };
        case HelpSupportActionTypes.SUPPORT_DATA_RESET:
            return GET_SUPPORT_DATA_INITIAL_STATE;
        default:
            return state;
    }
};

const supportAdminReducer = (state = GET_SUPPORT_ADMIN_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case HelpSupportActionTypes.SUPPORT_ADMIN_DATA_LOADING:
            return {
                supportAdmin: state.supportAdmin,
                loading: true,
            };
        case HelpSupportActionTypes.SUPPORT_ADMIN_DATA_SUCCESS:
            return {
                supportAdmin: action.payload,
                loading: false,
            };
        case HelpSupportActionTypes.SUPPORT_ADMIN_DATA_ERROR:
            return {
                supportAdmin: action.payload,
                loading: false,
            };
        case HelpSupportActionTypes.SUPPORT_ADMIN_DATA_RESET:
            return GET_SUPPORT_ADMIN_DATA_INITIAL_STATE;
        default:
            return state;
    }
};

const updateSupportReducer = (state = UPDATE_SUPPORT_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case HelpSupportActionTypes.UPDATE_SUPPORT_DATA_LOADING:
            return {
                ...state,
                loading: true,
            };
        case HelpSupportActionTypes.UPDATE_SUPPORT_DATA_SUCCESS:
            return {
                supportData: action.payload,
                loading: false,
            };
        case HelpSupportActionTypes.UPDATE_SUPPORT_DATA_ERROR:
            return {
                supportData: action.payload,
                // error: action.payload,
                loading: false,
            };
        case HelpSupportActionTypes.UPDATE_SUPPORT_DATA_RESET:
            return UPDATE_SUPPORT_DATA_INITIAL_STATE;
        default:
            return state;
    }
};

const createChatReducer = (state = CREATE_CHAT_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case HelpSupportActionTypes.CREATE_CHAT_DATA_LOADING:
            return {
                createChat: state.createChat,
                loading: true,
            };
        case HelpSupportActionTypes.CREATE_CHAT_DATA_SUCCESS:
            return {
                createChat: action.payload,
                loading: false,
            };
        case HelpSupportActionTypes.CREATE_CHAT_DATA_RESET:
            return CREATE_CHAT_DATA_INITIAL_STATE;
        case HelpSupportActionTypes.CREATE_CHAT_DATA_ERROR:
            return {
                createChat: action.payload,
                loading: false,
            };

        default:
            return state;
    }
};

const getChatReducer = (state = GET_CHAT_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case HelpSupportActionTypes.GET_CHAT_DATA_LOADING:
            return {
                getChat: state.getChat,
                loading: true,
            };
        case HelpSupportActionTypes.GET_CHAT_DATA_SUCCESS:
            return {
                getChat: action.payload,
                loading: false,
            };
        case HelpSupportActionTypes.GET_CHAT_DATA_ERROR:
            return {
                getChat: action.payload,
                loading: false,
            };
        case HelpSupportActionTypes.GET_CHAT_DATA_RESET:
            return GET_CHAT_DATA_INITIAL_STATE;
        default:
            return state;
    }
};
const getTicketByIdReducer = (state = GET_TICKET_BY_ID_INITIAL_STATE, action) => {
    switch (action.type) {
        case HelpSupportActionTypes.GET_TICKET_BY_ID_LOADING:
            return {
                getTicket: state.getTicket,
                loading: true,
            };
        case HelpSupportActionTypes.GET_TICKET_BY_ID_SUCCESS:
            return {
                getTicket: action.payload,
                loading: false,
            };
        case HelpSupportActionTypes.GET_TICKET_BY_ID_ERROR:
            return {
                getTicket: action.payload,
                loading: false,
            };
        case HelpSupportActionTypes.GET_TICKET_BY_ID_RESET:
            return GET_TICKET_BY_ID_INITIAL_STATE;
        default:
            return state;
    }
};

export { createSupportReducer, supportReducer, supportAdminReducer, updateSupportReducer, createChatReducer, getChatReducer, getTicketByIdReducer };
